import { configureStore } from '@reduxjs/toolkit';
import { categoriesApi, ccApi, recommendationsResultsApi, searchApi, searchProductApi, userProfileApi, } from './api';
import { createMiddlewareArray, persistedStoreEnhancer } from './middleware';
import createReducers from './reducers';
import { getConfig } from '@/config';
import { ls, USER_PROFILE_CACHE_KEY } from '@/stores/local-storage';
/**
 * All client-key authenticated API slices.
 * Add new slices here — middleware and reducers are wired automatically.
 */
const clientKeyApis = [recommendationsResultsApi, categoriesApi, searchProductApi, searchApi];
export default function createStore() {
    const middlewareArray = createMiddlewareArray();
    const store = configureStore({
        reducer: createReducers(),
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            // Disable serializability and immutability checks for performance and compatibility
            serializableCheck: false,
            immutableCheck: false,
            // Thunk is now available for use alongside listener middleware
            thunk: true,
        }).concat(ccApi.middleware, ...clientKeyApis.map((api) => api.middleware)).concat(middlewareArray),
        // Redux DevTools configuration
        devTools: {
            maxAge: 300,
            name: 'Brain Studio',
        },
        // Apply store enhancers for persistence if authentication is enabled
        enhancers: (getDefaultEnhancers) => {
            const enhancers = getDefaultEnhancers();
            if (!getConfig().skipAuthentication) {
                enhancers.push(persistedStoreEnhancer());
            }
            return enhancers;
        },
    });
    // Hydrate user profile cache from localStorage for instant availability on startup
    const cachedProfile = ls.getItem(USER_PROFILE_CACHE_KEY);
    if (cachedProfile) {
        void store.dispatch(userProfileApi.util.upsertQueryData('getUserProfile', undefined, cachedProfile));
    }
    if (module.hot) {
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        module.hot.accept('./reducers/', () => import('./reducers').then(({ default: hotCreateReducers }) => store.replaceReducer(hotCreateReducers())));
    }
    return store;
}
